// export const BASE_URL = "https://noncoreuat.pcmcindia.gov.in:8443";
export const DEV_BASE_URL = "http://103.224.247.159:8080/propertytax-web-api-dev";
export const PROD_BASE_URL = "http://103.224.247.159:8080/propertytax-web-api-prod";
export const CONTEXT_ROOT = "";
export const errorMsg = "Something went wrong please try again!!";
// eslint-disable-next-line no-unused-vars
export const options = [
  {
    label: "Cheque",
    value: "cheque",
  },
  {
    label: "Cheque 1",
    value: "cheque 1",
  },
  {
    label: "Cheque 2",
    value: "cheque 2",
  },
];

export const potkirdBillReceiptMapping = {
  tax39: "अवैध बांधकाम शास्ती",
  tax7: "विशेष साफसफाई कर",
  tax8: "वृक्ष उपकर",
  tax10: "रोजगार हमी कर",
  tax45: "अवैध बांधकाम शास्ती फरकबील2012-13,13-14",
  tax1: "सामान्य कर",
  tax21: "मलप्रवाह सुविधा लाभकर",
  tax36: "पाणीपुरवठा लाभकर",
  tax5: "फ़्लोअरेज कर",
  tax6: "शिक्षण कर",
  tax25: "फ़ाजील वसुली",
  tax38: "रस्ता कर",
  tax14: "प्रशासकीय सेवा शुल्क",
  tax43: "अनादर धनादेश वसुल",
  tax23: "रोजगार हमी कर विलंब दंड",
  tax28: "मनपा कर विलंब दंड ",
  tax24: "शिक्षण कर विलंब दंड",
  tax29: "फ़्लोरेज कर विलंब दंड",
  taxCommon3945: "अवैध बांधकाम शास्ती",
};

export const generalReceiptHeads = {
  tax41: "अनादर धनादेश सेवा शुल्क",
  tax12: "थकबाकी नसलेचा दाखला फ़ी",
  tax47: "हस्तांतरण फी विलंब शुल्क",
  tax46: "लेखा परिक्षण आक्षेप पुर्तता",
  tax42: "माहिती अधिकार फी",
  tax37: "इतर",
  tax40: "नक्कल फ़ी",
  tax11: "हस्तांतर नोटीस फी",
  tax13: "मालमत्ता उतारा फी",
};
